"use client";

import * as React from "react";
import { GallerySection10 } from "./gallery-section-10";

type CardsSliderHorisontalProps = React.ComponentProps<typeof GallerySection10>;

export function CardsSliderHorisontal(props: CardsSliderHorisontalProps) {
  return <GallerySection10 {...props} />;
}

CardsSliderHorisontal.displayName = "Cards Slider Horisontal";
